export default __webpack_public_path__ + "static/media/logodev.c106aece.png";